/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'
import config from '../../../config'
import helpIcon from '../assets/help-icon.png'

interface Props {}
function NeedHelp(props: Props) {
  const email = config.emails.support
  if (!email) return null

  return (
    <a href={`mailto:${email}`} target={'_blank'} rel="noreferrer">
      <Grid container alignItems={'center'}>
        <img
          src={helpIcon}
          alt={'help'}
          css={css`
            width: 23px;
            height: 23px;
            margin-right: 10px;
          `}
        />
        <Typography
          css={css`
            font-size: 20px;
            line-height: 30px;
            color: #6a707e;
          `}
        >
          I need help
        </Typography>
      </Grid>
    </a>
  )
}

export default NeedHelp
